import type { JSX } from "solid-js";
import type { ScanSectionKey } from "../../enums/scan";
import type { WebsiteContext } from "../website/store";
import { ScanSideRail } from "./ScanSideRail";
import { ScanTopBar } from "./ScanTopBar";

export function ScanShell(props: {
  context: WebsiteContext;
  active: ScanSectionKey;
  children: JSX.Element;
}) {
  return (
    <div class="signal-app">
      <ScanTopBar context={props.context} activeModule="scan" />
      <div class="signal-shell">
        <ScanSideRail context={props.context} active={props.active} />
        <main class="signal-workspace">{props.children}</main>
      </div>
    </div>
  );
}
